import React from "react"
import { Col, Row, Typography } from "antd"
import { PrismicDocument } from "@prismicio/types"
import { Section } from "../Section"
import { getPressMentionPost } from "../../lib/prismic/getPressMentionPost"
import Image from "next/image"
import styled from "@emotion/styled"
import Link from "next/link"
import { theme } from "../../styles/styles"
import { css } from "@emotion/react"

export const PressMentions: React.FC<Props> = ({ pressMentions }) => {
  if (pressMentions.length === 0) {
    return null
  }

  return (
    <Section
      css={css`
        overflow: hidden;
      `}>
      <Typography.Title level={2}>
        <Link href="/napsali-o-nas">Napsali o nás</Link>
      </Typography.Title>

      <Row gutter={[10, 10]}>
        {pressMentions
          .map((p) => getPressMentionPost(p))
          .filter((p) => p.highlighted)
          .map(({ id, image, url, name }) => {
            return (
              <ColWithSpace key={id} md={24 / 4} xs={24 / 2}>
                <Link href={url}>
                  <Inner>
                    <Image
                      src={image.url}
                      alt={image.alt?.length > 0 ? image.alt : `image-${name}`}
                      width={300}
                      height={150}
                      style={{ objectFit: "contain", filter: "grayscale(1)" }}
                    />
                  </Inner>
                </Link>
              </ColWithSpace>
            )
          })}
      </Row>
    </Section>
  )
}

interface Props {
  pressMentions: PrismicDocument[]
}

const ColWithSpace = styled(Col)``

const Inner = styled.div`
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  opacity: 0.85;
  transition: ${theme.effects.transition.default};

  &:hover {
    opacity: 1;
  }
`
